// This file is auto-generated on 2026-11-03 13:38:10 +0100 by bin/rails stimulus:site_manifest:update
// Run that command whenever you add a new controller or create them with
// bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiviteitTijdstipController from "./activiteit_tijdstip_controller"
application.register("activiteit-tijdstip", ActiviteitTijdstipController)

import AdresboekController from "./adresboek_controller"
application.register("adresboek", AdresboekController)

import CampagneKeuzeController from "./campagne_keuze_controller"
application.register("campagne-keuze", CampagneKeuzeController)

import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)

import ContextualLinkController from "./contextual_link_controller"
application.register("contextual-link", ContextualLinkController)

import CookiesController from "./cookies_controller"
application.register("cookies", CookiesController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DigitMaskController from "./digit_mask_controller"
application.register("digit-mask", DigitMaskController)

import DoelgroepenInfoController from "./doelgroepen_info_controller"
application.register("doelgroepen-info", DoelgroepenInfoController)

import DoelgroepenToggleController from "./doelgroepen_toggle_controller"
application.register("doelgroepen-toggle", DoelgroepenToggleController)

import ExtendedNestedFormController from "./extended_nested_form_controller"
application.register("extended-nested-form", ExtendedNestedFormController)

import ExternalControlsNestedFormController from "./external_controls_nested_form_controller"
application.register("external-controls-nested-form", ExternalControlsNestedFormController)

import FormActionsController from "./form_actions_controller"
application.register("form-actions", FormActionsController)

import KalenderController from "./kalender_controller"
application.register("kalender", KalenderController)

import MediaZoomController from "./media_zoom_controller"
application.register("media-zoom", MediaZoomController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OrganisatiesoortController from "./organisatiesoort_controller"
application.register("organisatiesoort", OrganisatiesoortController)

import PublicatiesController from "./publicaties_controller"
application.register("publicaties", PublicatiesController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import RelatedFiltersController from "./related_filters_controller"
application.register("related-filters", RelatedFiltersController)

import ResourceController from "./resource_controller"
application.register("resource", ResourceController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)

import WithCounterNestedFormController from "./with_counter_nested_form_controller"
application.register("with-counter-nested-form", WithCounterNestedFormController)

import ZoekController from "./zoek_controller"
application.register("zoek", ZoekController)

import ZoekveldController from "./zoekveld_controller"
application.register("zoekveld", ZoekveldController)
